import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Import modal
import DocumentStatusModal from "../modals/DocumentStatusModal";

const DocumentRequests = () => {
  const routes = all_routes;
  const [filter, setFilter] = useState("all");
  const [selectedDocumentRequest, setSelectedDocumentRequest] =
    useState<any>(null);

  // Enhanced mock document requests data
  const mockRequests = [
    {
      id: 1,
      requestId: "REQ-2024-001",
      documentType: "Transfer Certificate",
      studentName: "Emily Johnson",
      studentId: "STU-2024-456",
      requestDate: "2024-12-20",
      status: "In Progress",
      expectedDate: "2024-12-27",
      priority: "Medium",
      purpose: "Family relocation to another state",
      copies: 2,
      processingFee: 25.0,
      adminComments: "Processing initiated. Verification in progress.",
      statusHistory: [
        {
          status: "Submitted",
          date: "2024-12-20 09:00",
          comments: "Request submitted successfully",
        },
        {
          status: "In Progress",
          date: "2024-12-21 14:30",
          comments: "Document verification started",
        },
      ],
    },
    {
      id: 2,
      requestId: "REQ-2024-002",
      documentType: "Character Certificate",
      studentName: "Emily Johnson",
      studentId: "STU-2024-456",
      requestDate: "2024-12-18",
      status: "Approved",
      expectedDate: "2024-12-25",
      priority: "Low",
      purpose: "Required for scholarship application",
      copies: 1,
      processingFee: 15.0,
      approvedDate: "2024-12-22",
      adminComments: "All documents verified. Approved for processing.",
      statusHistory: [
        {
          status: "Submitted",
          date: "2024-12-18 10:15",
          comments: "Request submitted successfully",
        },
        {
          status: "In Progress",
          date: "2024-12-19 11:00",
          comments: "Under review",
        },
        {
          status: "Approved",
          date: "2024-12-22 16:45",
          comments: "Approved and queued for printing",
        },
      ],
    },
    {
      id: 3,
      requestId: "REQ-2024-003",
      documentType: "Grade Report",
      studentName: "Emily Johnson",
      studentId: "STU-2024-456",
      requestDate: "2024-12-15",
      status: "Ready for Pickup",
      expectedDate: "2024-12-22",
      priority: "High",
      purpose: "University admission requirement",
      copies: 3,
      processingFee: 20.0,
      rushFee: 10.0,
      approvedDate: "2024-12-20",
      completedDate: "2024-12-23",
      adminComments: "Document ready for collection at main office.",
      statusHistory: [
        {
          status: "Submitted",
          date: "2024-12-15 14:00",
          comments: "Rush processing requested",
        },
        {
          status: "In Progress",
          date: "2024-12-16 09:30",
          comments: "Priority processing initiated",
        },
        {
          status: "Approved",
          date: "2024-12-20 11:00",
          comments: "Approved for immediate processing",
        },
        {
          status: "Ready for Pickup",
          date: "2024-12-23 15:00",
          comments: "Document printed and ready for collection",
        },
      ],
    },
    {
      id: 4,
      requestId: "REQ-2024-004",
      documentType: "Attendance Certificate",
      studentName: "Emily Johnson",
      studentId: "STU-2024-456",
      requestDate: "2024-12-10",
      status: "Rejected",
      expectedDate: "N/A",
      priority: "Medium",
      purpose: "Insurance claim documentation",
      copies: 1,
      processingFee: 15.0,
      rejectionReason:
        "Student has excessive absences (>20%). Attendance certificate cannot be issued until attendance improves to required standards.",
      allowResubmission: true,
      adminComments:
        "Please contact academic office to discuss attendance improvement plan.",
      statusHistory: [
        {
          status: "Submitted",
          date: "2024-12-10 13:20",
          comments: "Request submitted for review",
        },
        {
          status: "In Progress",
          date: "2024-12-11 10:00",
          comments: "Attendance records being verified",
        },
        {
          status: "Rejected",
          date: "2024-12-12 16:30",
          comments: "Insufficient attendance percentage",
        },
      ],
    },
  ];

  const filteredRequests = mockRequests.filter((request) => {
    if (filter !== "all")
      return request.status.toLowerCase().replace(" ", "") === filter;
    return true;
  });

  const handleViewDetails = (request: any) => {
    setSelectedDocumentRequest(request);
  };

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case "pending":
        return "badge-soft-warning";
      case "in progress":
        return "badge-soft-info";
      case "approved":
        return "badge-soft-success";
      case "ready for pickup":
        return "badge-soft-primary";
      case "rejected":
        return "badge-soft-danger";
      default:
        return "badge-soft-secondary";
    }
  };

  const getPriorityColor = (priority: string) => {
    switch (priority.toLowerCase()) {
      case "high":
        return "text-danger";
      case "medium":
        return "text-warning";
      case "low":
        return "text-success";
      default:
        return "text-muted";
    }
  };

  const getStatsCount = (status: string) => {
    return mockRequests.filter((req) => req.status === status).length;
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between border-bottom pb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Document Requests</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.parentDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Parent</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Document Requests
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <div className="pe-1 mb-2">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Refresh</Tooltip>}
              >
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white btn-icon me-1"
                >
                  <i className="ti ti-refresh" />
                </Link>
              </OverlayTrigger>
            </div>
            <div className="pe-1 mb-2">
              <button
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#newRequestModal"
              >
                <i className="ti ti-plus me-2"></i>New Request
              </button>
            </div>
          </div>
        </div>

        {/* Stats Cards */}
        <div className="row mt-4">
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-primary-transparent me-3">
                    <i className="ti ti-file-text"></i>
                  </div>
                  <div>
                    <h4>{mockRequests.length}</h4>
                    <p className="text-muted mb-0">Total Requests</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-info-transparent me-3">
                    <i className="ti ti-clock"></i>
                  </div>
                  <div>
                    <h4>{getStatsCount("In Progress")}</h4>
                    <p className="text-muted mb-0">In Progress</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-success-transparent me-3">
                    <i className="ti ti-check"></i>
                  </div>
                  <div>
                    <h4>{getStatsCount("Ready for Pickup")}</h4>
                    <p className="text-muted mb-0">Ready</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6">
            <div className="card">
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="avatar avatar-lg bg-warning-transparent me-3">
                    <i className="ti ti-bell"></i>
                  </div>
                  <div>
                    <h4>{getStatsCount("Approved")}</h4>
                    <p className="text-muted mb-0">Approved</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h4 className="card-title">Request History</h4>
                <div className="d-flex gap-2">
                  <select
                    className="form-select form-select-sm"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  >
                    <option value="all">All Requests</option>
                    <option value="inprogress">In Progress</option>
                    <option value="approved">Approved</option>
                    <option value="readyforpickup">Ready for Pickup</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th>Request ID</th>
                        <th>Document Type</th>
                        <th>Request Date</th>
                        <th>Status</th>
                        <th>Priority</th>
                        <th>Expected Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRequests.map((request) => (
                        <tr key={request.id}>
                          <td>
                            <Link
                              to="#"
                              className="text-primary fw-semibold"
                              data-bs-toggle="modal"
                              data-bs-target="#documentStatusModal"
                              onClick={() => handleViewDetails(request)}
                            >
                              {request.requestId}
                            </Link>
                          </td>
                          <td>
                            <div>
                              <h6 className="mb-0">{request.documentType}</h6>
                              <small className="text-muted">
                                {request.studentName}
                              </small>
                            </div>
                          </td>
                          <td>{request.requestDate}</td>
                          <td>
                            <span
                              className={`badge ${getStatusColor(
                                request.status
                              )}`}
                            >
                              {request.status}
                            </span>
                          </td>
                          <td>
                            <span
                              className={getPriorityColor(request.priority)}
                            >
                              <i className="ti ti-circle-filled me-1"></i>
                              {request.priority}
                            </span>
                          </td>
                          <td>{request.expectedDate}</td>
                          <td>
                            <div className="dropdown">
                              <button
                                className="btn btn-outline-light btn-sm dropdown-toggle"
                                data-bs-toggle="dropdown"
                              >
                                Actions
                              </button>
                              <ul className="dropdown-menu">
                                <li>
                                  <button
                                    className="dropdown-item"
                                    data-bs-toggle="modal"
                                    data-bs-target="#documentStatusModal"
                                    onClick={() => handleViewDetails(request)}
                                  >
                                    <i className="ti ti-eye me-2"></i>View
                                    Details
                                  </button>
                                </li>
                                {request.status === "Ready for Pickup" && (
                                  <li>
                                    <button className="dropdown-item">
                                      <i className="ti ti-download me-2"></i>
                                      Download
                                    </button>
                                  </li>
                                )}
                                {request.status === "In Progress" && (
                                  <li>
                                    <button className="dropdown-item text-danger">
                                      <i className="ti ti-x me-2"></i>Cancel
                                      Request
                                    </button>
                                  </li>
                                )}
                                <li>
                                  <hr className="dropdown-divider" />
                                </li>
                                <li>
                                  <button className="dropdown-item">
                                    <i className="ti ti-message me-2"></i>
                                    Contact Support
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {filteredRequests.length === 0 && (
                  <div className="text-center py-5">
                    <div className="avatar avatar-xl bg-light-transparent mx-auto mb-3">
                      <i className="ti ti-file-text fs-2"></i>
                    </div>
                    <h5>No requests found</h5>
                    <p className="text-muted">
                      No document requests match your current filter.
                    </p>
                    <button
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#newRequestModal"
                    >
                      <i className="ti ti-plus me-2"></i>Submit New Request
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* New Request Modal */}
      <div className="modal fade" id="newRequestModal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Submit Document Request</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Student Name</label>
                    <select className="form-select">
                      <option>Emily Johnson</option>
                      <option>Michael Johnson</option>
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Document Type</label>
                    <select className="form-select">
                      <option>Transfer Certificate</option>
                      <option>Character Certificate</option>
                      <option>Grade Report</option>
                      <option>Attendance Certificate</option>
                      <option>Bonafide Certificate</option>
                    </select>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Priority</label>
                    <select className="form-select">
                      <option>Normal</option>
                      <option>High</option>
                      <option>Urgent</option>
                    </select>
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Required Date</label>
                    <input type="date" className="form-control" />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Purpose/Reason</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    placeholder="Please specify the reason for this document request..."
                  ></textarea>
                </div>
                <div className="mb-3">
                  <label className="form-label">Supporting Documents</label>
                  <input type="file" className="form-control" multiple />
                  <small className="text-muted">
                    Upload any supporting documents if required
                  </small>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button type="button" className="btn btn-primary">
                Submit Request
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Document Status Modal */}
      <DocumentStatusModal documentRequest={selectedDocumentRequest} />
    </div>
  );
};

export default DocumentRequests;
